export const GENERIC_SIZE_CHART = {
  clothing: "Clothing",
  imageBlock1: "Image Block 1",
  imageBlock2: "Image Block 2",
  imageBlock3: "Image Block 3"
};
